export default "__VITE_ASSET__ObhStdyu__"